module.exports = __webpack_public_path__ + "img/vertical_2_1_8003.32e77afe.png";